import { Grid, Button } from "../../../../components";

export const ButtonMenu = ({ onClickCancelar }) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ mb: "0.5em" }}
    >
      <Button
        className="my-3 ms-2"
        variant="outlined"
        color="primary"
        size="small"
        onClick={onClickCancelar}
      >
        Cancelar
      </Button>
    </Grid>
  );
};
